import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { useEffect, useMemo } from 'react'
import getMuiTheme from './utils/themeUtils'
import { DARK_THEME, LIGHT_THEME } from './utils/themeConstants'
import routes from './config/routes'
import protectedRoutes from './config/protectedRoutes'
import { IRoute } from './config/types'
import RequireAuth from './components/RequireAuth'
import RequireFullOrg from './components/RequireFullOrg'
import PublicRoutes from './components/PublicRoutes'
import { useLocation } from 'react-router-dom'
import MobileViewHandler from './components/MobileViewHandler'
import MobileViewPage from './components/MobileViewPage'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'


const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const elToScroll = document.querySelector('.t-viewport-body')
    elToScroll && elToScroll.scrollTo(0, 0)
  }, [pathname])

  return null
}

function App() {
  const lightTheme = 'light'
  const appMuiTheme = useMemo(
    () => (lightTheme === 'light' ? getMuiTheme(LIGHT_THEME) : getMuiTheme(DARK_THEME)),
    [lightTheme],
  )

  const renderPublicRoutes = () => {
    return routes.map((route: IRoute) => {
      return <Route key={route.name} path={route.path} element={<route.component />} />
    })
  }

  const renderProtectedRoutes = () => {
    return protectedRoutes.map((route: IRoute) => {
      if (route.children && route.children.length !== 0) {
        return (
          <Route key={route.name} path={route.path} element={<route.component />}>
            <Route element={<RequireFullOrg />}>
              {route.children.map((childRoute: IRoute) => {
                return (
                  <Route
                    key={childRoute.name}
                    path={childRoute.path}
                    element={<childRoute.component />}
                  />
                )
              })}
            </Route>
          </Route>
        )
      }
      return <Route key={route.name} path={route.path} element={<route.component />} />
    })
  }




  return (
    <MuiThemeProvider theme={appMuiTheme}>
      <ToastContainer position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<MobileViewHandler />}>
            <Route
              path={'mobileWarningPage'}
              key={'mobileWarningPage'}
              element={<MobileViewPage />}
            />
            <Route element={<PublicRoutes />}>{renderPublicRoutes()}</Route>
            <Route element={<RequireAuth />}>
              <Route path='/' key='' element={<Navigate to='cases/inbox' replace />} />
              {renderProtectedRoutes()}
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>

    </MuiThemeProvider>
  )
}

export default App
